import React, {Component} from 'react';

import * as FitbitComponents from './fitbit-components';

type SettingsComponentType = () => Element<*> | Component<*, *, *>;
type BuiltInsType = $Keys<typeof FitbitComponents>;

const createComponent = (
  type: BuiltInsType | SettingsComponentType,
  options: *,
  ...children: *[]
): * => {
  // Must be a builtin to convert otherwise it should be a custom component
  if (typeof type === 'string') {
    if (FitbitComponents[type]) {
      children = React.Children.map(children, child => {
        if (
          !child ||
          !child.type ||
          !FitbitComponents[child.type._type]
        ) {
          return child;
        }
        return React.cloneElement(child, {
          _parent: type
        });
      });
      type = FitbitComponents[type];
    } else {
      throw new Error(`${type}: Is not a valid Component type.`);
    }
  }

  // $FlowFixMe - Complains about React$Component not working with React$Element
  return React.createElement(type, options, ...children);
};

export default createComponent;



// WEBPACK FOOTER //
// ./src/create-component.js